import { render, staticRenderFns } from "./Sweden.vue?vue&type=template&id=dd40d918&scoped=true"
import script from "./Sweden.vue?vue&type=script&lang=js"
export * from "./Sweden.vue?vue&type=script&lang=js"
import style0 from "./Sweden.vue?vue&type=style&index=0&id=dd40d918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd40d918",
  null
  
)

export default component.exports